/*
    URLS without error dialog
*/
export const geoUrls = [
    'api/geo/countries',
    'api/geo/states'
];

export const baseDataUrls = [
    'api/baseData/colors/.+',
    'api/baseData/markings/.+'
];

export const registrationProcessingMetadataUrls = [
    'api/registration-processing-metadata/feeTypeByVersion/.+'
];

export const loginBridge = [
    '/login-bridge/.+'
];

export const completeTxn = [
    '/payment-edge/api/payment/complete'
];

export const preflightCommand = 'api/regis/commands/preflight';

// Ignore popup dialog for specific url and error code
// the object should be {code: ###, url: 'endpoint'}
export const ignoreByUrlAndErrorCode = [
];
